exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-Du_hg{background-color:#042b75}.clickBar-DASH2{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:20px;cursor:pointer}.arrow-22HJ6{margin-right:20px;width:20px !important;-webkit-transition:.3s;transition:.3s}.arrow-22HJ6.reverse-3lk_U{-webkit-transform:rotateX(180deg);transform:rotateX(180deg);-webkit-transition:.3s;transition:.3s}.title-1qhFo{margin-bottom:0}.content-7TPde{padding:0 60px 20px}.theme-dark .container-Du_hg{background-color:#042b75}.theme-light .container-Du_hg{background-color:#fff}", ""]);

// exports
exports.locals = {
	"container": "container-Du_hg",
	"clickBar": "clickBar-DASH2",
	"arrow": "arrow-22HJ6",
	"reverse": "reverse-3lk_U",
	"title": "title-1qhFo",
	"content": "content-7TPde"
};